jQuery(function ($) {  
    //Home Review Slider
    $(".ReviewSlider").owlCarousel({
      loop: false,
      margin: 30,
      dots: true,
      nav: false,
      autoplay: false,
      autoplayTimeout: 4000,
      autoplayHoverPause: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
        },
        576: {
          margin: 20,
          items: 2,
        },
        991: {
          items: 3,
        },
      },
    });
    //    < ------------------------------------------------------>
    //Home Slider
      $(".CategorySlider").owlCarousel({
        loop: false,
        margin: 30,
        dots: true,
        nav: false,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          576: {
            margin: 20,
            items: 2,
          },
          991: {
            items: 3,
          },
        },
      });
    //    < ------------------------------------------------------>
    //Body Slider
      $(".BodySlider").owlCarousel({
        items: 1,
        loop: true,
        margin: 0,
        dots: true,
        nav: true,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        navText: ['<i class="fa fa-arrow-left" aria-hidden="true"></i>','<i class="fa fa-arrow-right" aria-hidden="true"></i>'],
      });
    // < ---------------------------------------------------------- >
    //Features Slider
      $(".FeaturesSlider").owlCarousel({
        items: 1,
        loop: true,
        margin: 0,
        dots: true,
        nav: true,
        autoplay: false,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        navText: ['<i class="fa fa-arrow-left" aria-hidden="true"></i>','<i class="fa fa-arrow-right" aria-hidden="true"></i>'],
      });
    // < ---------------------------------------------------------- >

  const paragraphs = document.querySelectorAll('.last-word');
    paragraphs.forEach(paragraph => {
        const words = paragraph.textContent.split(' ');
        const lastWord = words[words.length - 1];
        paragraph.innerHTML = paragraph.innerHTML.replace(lastWord, `<span class="last-word">${lastWord}</span>`);
    });

  
});